import { OutlinedButton, OutlinedButtonProps } from '../OutlinedButton/OutlinedButton';
import s from './AddButton.module.scss';
import { AddIcon } from '@/assets';

type Props = Omit<OutlinedButtonProps, 'icon' | 'iconAltText'>;

export function AddButton({ onClick, children, className, ...rest }: Props) {
  return (
    <OutlinedButton
      icon={AddIcon}
      iconAltText="add icon"
      onClick={onClick}
      className={[className, s.addButton].join(' ')}
      {...rest}
    >
      {children}
    </OutlinedButton>
  );
}
